module.exports = {
    config: {
        controls: {
            request: false,
            order: false,
            cancel: false,
            requestOffer: false,
        }
    },

    methods: {
        onBeforeRender(){
            let projectStatus
            this.closest('base_form_form', projectProperties => {
                projectStatus = ((projectProperties.resourceData.data || {}).attributes || {}).status
            })

            this.config.controls.request = projectStatus === 'draft'
            this.config.controls.order = projectStatus === 'confirmed'
            this.config.controls.cancel = projectStatus === 'fixed'
            this.config.controls.requestOffer = (
                (projectStatus === 'draft' || projectStatus === 'request' || projectStatus === 'confirmed' || projectStatus === 'ordered')
            )
        },
    },
}